import React from "react";
import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import theme from "../theme/theme";

interface Props {
  title?: string;
  type?: string;
  onChange: (value: string) => void;
  errorMessage?: string;
  required?: boolean;
  disabled?: boolean;
  multiline?: boolean;
  icon?: JSX.Element;
  value?: string;
  endIcon?: JSX.Element;
  onClick?(): void;
  inputStyle?: React.CSSProperties;
  rootStyle?: React.CSSProperties;
  placeholder?: string;
  component?: JSX.Element;
  rows?: number;
  size?: "small" | "medium";
}

const SigninTextInput = ({
  title,
  type = "text",
  onChange,
  errorMessage,
  required,
  disabled,
  icon,
  value,
  endIcon,
  onClick,
  inputStyle,
  rootStyle,
  placeholder,
  component,
  multiline,
  rows,
  size,
  ...rest
}: Props) => {
  return (
    <Box
      sx={{
        marginTop: 3,
        width: "100%",
        ...rootStyle,
      }}
    >
      {title ? (
        <Typography
          color="black"
          sx={{
            fontSize: {
              xs: 12,
              md: 14,
            },
            mb: 1,
          }}
        >
          {title}
        </Typography>
      ) : null}
      {!component ? (
        <TextField
          placeholder={placeholder || title}
          type={type}
          required={required}
          color="secondary"
          className="inputField"
          variant="outlined"
          size={size}
          style={{
            width: "100%",
            backgroundColor: "#fff",
            ...inputStyle,
          }}
          autoComplete="off"
          InputProps={{
            style: { borderRadius: 4 },
            sx: { fontSize: { xs: 12, md: 14 } },
            startAdornment: (
              <InputAdornment position="start">{icon}</InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">{endIcon}</InputAdornment>
            ),
            autoComplete: "off",
          }}
          value={value}
          disabled={disabled}
          multiline={multiline}
          rows={rows}
          onChange={(e) => onChange(e.target.value)}
          onClick={onClick}
          {...rest}
        />
      ) : (
        component
      )}
      {errorMessage !== "" ? (
        <small style={{ color: theme.colors.red, fontSize: 10 }}>
          {errorMessage}
        </small>
      ) : null}
    </Box>
  );
};

export default SigninTextInput;
